var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "waste-streams o-grid o-grid--center",
      class: { "waste-streams--highlighted": _vm.hasActiveWasteStream }
    },
    _vm._l(_vm.wasteStreams, function(wasteStream, index) {
      return _c(
        "div",
        { key: index, staticClass: "waste-stream o-grid__col u-1/12" },
        [
          _c(
            "a",
            {
              staticClass: "waste-stream__item",
              class: {
                "waste-stream__item--active":
                  _vm.activeWasteStreamId === wasteStream.id
              },
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function($event) {
                  return _vm.setActiveWasteStreamId(wasteStream.id)
                }
              }
            },
            [
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: wasteStream.icon,
                    expression: "wasteStream.icon"
                  }
                ],
                attrs: { src: wasteStream.icon, alt: wasteStream.name }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "arrow" })
            ]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }